export enum UploadStatus {
    QUEUED,
    IN_PROGRESS,
    COMPLETE,
};